import React from "react";

import Settings from "../../../../services/settings.service";
import Translation from "../../../../services/translation.service";
import Helpers from "../../../../helpers/shared.helper";
import { OUTCOME_TYPES, submissionOutcomes } from "../data/submissionOutcomes";
import { translationPrefix } from "../data";

const FormSubmissionOutcome = ({
  onContinue,
  outcome = OUTCOME_TYPES.SUCCESS_POSITIVE,
  goToSiteHome,
}) => {
  const outcomeData = submissionOutcomes[outcome];

  if (!outcomeData) {
    console.error(`FormSubmissionOutcome: unknown outcome "${outcome}"`);
    Helpers.clearKeysFromSessionStorage([
      "survey_step",
      "survey_rating",
      "survey_feedback",
    ]);
    onContinue("rating");
    return null;
  }

  const isFailure = outcome === OUTCOME_TYPES.FAILURE;

  const handlePrimaryClick = () => {
    if (isFailure) {
      onContinue("rating");
    } else {
      goToSiteHome();
    }
  };

  const primaryButtonLabel = isFailure
    ? Translation.keys[translationPrefix + "survey_try_again"]
    : Translation.keys[translationPrefix + "survey_return_to_home"];

  const goToContactUsPage = () => {
    const link = Settings.get("contact_us");
    if (link && link.includes("%lang%")) {
      const contactUsPageLink = link.replace("%lang%", Translation.activeLang);
      window.location.href = contactUsPageLink;
    }
  };

  return (
    <div className="form-submission-outcome">
      <img src={outcomeData.logo} alt="Outcome icon" />
      <div className="title">
        {Translation.keys[translationPrefix + outcomeData.languageTitleKey]}
      </div>
      <div className="description">
        {
          Translation.keys[
            translationPrefix + outcomeData.languageDescriptionKey
          ]
        }
      </div>

      <button className="common-button" onClick={handlePrimaryClick}>
        {primaryButtonLabel}
      </button>

      {isFailure && (
        <>
          <button
            onClick={goToContactUsPage}
            className="common-button-light contact-us-btn"
          >
            {Translation.keys[translationPrefix + "survey_contact_us"]}
          </button>
          <div className="common-button-text" onClick={goToSiteHome}>
            {Translation.keys[translationPrefix + "survey_close"]}
          </div>
        </>
      )}
    </div>
  );
};

export default FormSubmissionOutcome;
